<template>
    <div>
       <v-container fluid class="my-5">
           <v-layout row wrap justify-end>
               <v-flex xs12 md3>
                   <!-- here we trigger create user functions -->
                    <NewUserPopUp/>
               </v-flex>
           </v-layout>
           <v-layout row justify-center>
            <v-data-table :headers="headers" :items="allUsers" class="elevation-1">
                <template v-slot:items="props">
                    <td class="text-xs-left">{{ props.item.name }} {{props.item.lastname}}</td>
                    <td class="text-xs-left">
                        <div v-for="client in props.item.clients" :key="client.id">
                            {{ client.role}}
                        </div>
                    </td>
                    <td class="text-xs-left" >
                        <div v-for="client in props.item.clients" :key="client.id">
                            {{ client.client.name }}
                        </div>
                    </td>
                    <td class="text-xs-left">
                        <v-btn fab dark small color="red" @click="deleteUser({ id: props.item.id })">
                            <v-icon>delete</v-icon>
                        </v-btn>
                    </td>
                </template>
            </v-data-table>

           </v-layout>
       </v-container>
    </div>
</template>

<script>
import NewUserPopUp from '@/components/User/NewUserPopUp'
import { mapActions, mapGetters } from 'vuex'


export default {
    components: {
        NewUserPopUp,
    },
    name: 'users',
    data() {
        return {
            headers: [
                {
                    text: 'Username',
                    align: 'left',
                    sortable: true,
                    value: 'name'
                },
                { text: 'Role', value: 'role' },
                { text: 'Clients', value: 'clients' },
                { text: 'Actions', value: 'actions' }
            ]
        }
    },
    methods:{
        ...mapActions([
            'deleteUser',
        ]),
    },
    computed: {
        ...mapGetters([
           'allUsers'
        ]),

    },
}
</script>